// Helpers shared by the Winkhaus and Schüco production monitoring pages.

// ─── Parse a Polish date: "DD.MM.YYYY" or "Tydz. WW.YYYY" ───
// Returns a Date (local time, midnight) or null when the value is not a date.
export const parsePLDate = (value) => {
  if (!value) return null;
  const s = String(value).trim();

  // "Tydz. XX.YYYY" (week format). Approximate: first day of the year + (week - 1) * 7 days.
  const weekMatch = s.match(/^Tydz\.\s*(\d{2})\.(\d{4})$/);
  if (weekMatch) {
    const [, week, year] = weekMatch;
    const weekStart = new Date(year, 0, 1);
    weekStart.setDate(weekStart.getDate() + (parseInt(week, 10) - 1) * 7);
    return weekStart;
  }

  const match = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (match) {
    const [, dd, mm, yyyy] = match;
    return new Date(yyyy, mm - 1, dd);
  }
  return null;
};

// ─── Tooltip with the previous delivery dates ───
// `originalDate` is the page-specific "original" field; `noHistoryPrefix` is the
// label used when the date was never changed.
export const buildDeliveryHistoryTooltip = (
  item,
  originalDate,
  noHistoryPrefix = 'Pierwotna'
) => {
  if (!item.delivery_date_history || item.delivery_date_history.length === 0) {
    return originalDate ? `${noHistoryPrefix}: ${originalDate}` : '';
  }
  const historyLines = item.delivery_date_history.map(
    h => `${h.date} (zmieniono ${h.changed_on})`
  );
  return `Poprzednie daty:\n${historyLines.join('\n')}\n\nPierwotna: ${originalDate || '—'}`;
};

// ─── Delivery status class used for colouring ───
export const getDeliveryStatusClass = (item) => {
  if (item.delivery_status === 'delayed') return 'om-delivery-delayed';
  if (item.delivery_status === 'earlier') return 'om-delivery-earlier';
  // Date changed but ended up the same as original
  if (item.delivery_date_history?.length > 0 && item.delivery_status === 'on_time') {
    return 'om-delivery-changed';
  }
  return '';
};
